function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('li.item-has-megamenu').forEach((megamenu) => {
  megamenu.addEventListener('mouseover', (event) => {
    megamenu.querySelector('details').setAttribute('open', '');
    document.querySelector('.header-wrapper').classList.add('active_hover');
  });
  megamenu.addEventListener('mouseout', (event) => {
    megamenu.querySelector('details').removeAttribute('open', '');
    document.querySelector('.header-wrapper').classList.remove('active_hover');
  });
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not([type="submit"])').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.querySelector('video')) {
      const video = this.querySelector('video');
      video.addEventListener('timeupdate', function () {
        var progress = (video.currentTime / video.duration) * 100;
        if (video.closest('.video-section__media-wrapper')) {
          video.closest('.video-section__media-wrapper').style.setProperty('--progress', progress);
        }
      });
      video.addEventListener('play', function () {
        if (video.closest('.video-section__media-wrapper')) {
          video.closest('.video-section__media-wrapper').classList.add('played');
        }
      });
      video.addEventListener('pause', function () {
        if (video.closest('.video-section__media-wrapper')) {
          video.closest('.video-section__media-wrapper').classList.remove('played');
        }
      });
      video.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
      video.addEventListener('ended', function (event) {
        if (video.closest('.video-section__media-wrapper')) {
          if (!video.hasAttribute('autoplay')) {
            video.closest('deferred-media').removeAttribute('loaded');
          }
        }
      });
    }
  }

  loadContent(focus = true) {
    if (this.querySelector('video')) {
      const deferredElement = this.querySelector('video');
      deferredElement.play();
      this.setAttribute('loaded', true);
      return;
    }
    window.pauseAllMedia(); //continue playing on medias
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

function isSlideshowSlideHidden(slide) {
  if (!slide?.classList) return false;
  if (slide.classList.contains('slideshow__slide--hide-desktop') && window.matchMedia('(min-width: 750px)').matches) {
    return true;
  }
  if (slide.classList.contains('slideshow__slide--hide-mobile') && window.matchMedia('(max-width: 749px)').matches) {
    return true;
  }
  return false;
}

function getVisibleSlideshowSlides(slider) {
  if (!slider) return [];
  return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => !isSlideshowSlideHidden(slide));
}

function normalizeSlideshowSectionId(raw) {
  return (raw || '').trim().replace(/^shopify-section-/, '');
}

function hasPendingPrependEmbedForSlideshow(sectionId) {
  const normalized = normalizeSlideshowSectionId(sectionId);
  if (!normalized) return false;
  return Array.from(document.querySelectorAll('template[data-slideshow-section-id]')).some((tpl) => {
    const id = normalizeSlideshowSectionId(tpl.dataset.slideshowSectionId);
    if (id !== normalized) return false;
    const insert = tpl.dataset.slideshowInsert || 'append';
    const isPrependPosition =
      insert === 'prepend' || (insert === 'custom' && parseInt(tpl.dataset.slideshowInsertIndex, 10) === 1);
    if (!isPrependPosition) return false;
    // Template stays in the DOM after inject — only treat as pending if the slide is not there yet.
    const embedSectionId = (tpl.dataset.embedSectionId || '').trim();
    if (embedSectionId && document.getElementById('Slide-' + normalized + '-embed-' + embedSectionId)) {
      return false;
    }
    return true;
  });
}

function hideSlideshowTrackForPrependEmbed(sectionId) {
  const id = normalizeSlideshowSectionId(sectionId);
  if (!id) return;
  const sectionEl = document.getElementById('shopify-section-' + id);
  if (!sectionEl) return;
  const slideshow = sectionEl.querySelector('slideshow-component');
  const slider = sectionEl.querySelector('[id^="Slider-"]');
  if (slideshow) {
    slideshow.setAttribute('data-await-prepend-embed', 'true');
    if (typeof slideshow.pause === 'function') slideshow.pause();
  }
  if (slider) {
    slider.classList.add('slideshow__track--await-prepend-embed');
  }
}

function revealSlideshowTrackAfterPrependEmbed(sectionId) {
  const id = normalizeSlideshowSectionId(sectionId);
  if (!id) return;
  const sectionEl = document.getElementById('shopify-section-' + id);
  if (!sectionEl) return;
  const slideshow = sectionEl.querySelector('slideshow-component');
  const slider = sectionEl.querySelector('[id^="Slider-"]');
  if (slider) {
    slider.classList.remove('slideshow__track--await-prepend-embed');
    if (typeof slider.scrollTo === 'function') {
      slider.scrollTo({ left: 0, behavior: 'instant' });
    } else {
      slider.scrollLeft = 0;
    }
  }
  if (slideshow) {
    slideshow.removeAttribute('data-await-prepend-embed');
    if (slideshow.dataset.autoplayPending === 'true') {
      delete slideshow.dataset.autoplayPending;
      if (
        slideshow.slider?.getAttribute('data-autoplay') === 'true' &&
        typeof slideshow.setAutoPlay === 'function'
      ) {
        slideshow.setAutoPlay();
      }
    }
  }
}

window.SlideshowBannerEmbed = {
  normalizeSlideshowSectionId,
  isSlideshowSlideHidden,
  getVisibleSlideshowSlides,
  hasPendingPrependEmbedForSlideshow,
  hideSlideshowTrackForPrependEmbed,
  revealSlideshowTrackAfterPrependEmbed,
};

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    requestAnimationFrame(() => this.initPages());
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    let items = Array.from(this.sliderItems);
    if (this.tagName === 'SLIDESHOW-COMPONENT') {
      items = getVisibleSlideshowSlides(this.slider);
    }
    const itemsWithWidth = items.filter((element) => element.clientWidth > 0);
    if (itemsWithWidth.length > 0) {
      items = itemsWithWidth;
    }
    if (items.length < 2) {
      items =
        this.tagName === 'SLIDESHOW-COMPONENT'
          ? getVisibleSlideshowSlides(this.slider)
          : Array.from(this.sliderItems);
    }
    if (items.length < 2) {
      items = Array.from(this.sliderItems);
    }
    this.sliderItemsToShow = items;
    if (items.length < 2) return;

    let offset = items[1].offsetLeft - items[0].offsetLeft;
    if (!offset || offset <= 0) {
      const a = items[0].getBoundingClientRect();
      const b = items[1].getBoundingClientRect();
      offset = Math.round(Math.abs(b.left - a.left));
    }
    if (!offset || offset <= 0) {
      offset =
        Math.round(items[0].getBoundingClientRect().width) ||
        items[0].offsetWidth ||
        items[0].clientWidth;
    }
    if (!offset || offset <= 0) {
      offset = this.slider.clientWidth;
    }
    if (!offset || offset <= 0) return;

    this.sliderItemOffset = offset;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;
    if (!this.sliderItemOffset || this.sliderItemOffset <= 0 || !this.sliderItemsToShow?.length) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (!Number.isFinite(this.currentPage)) this.currentPage = 1;
    this.currentPage = Math.min(
      Math.max(1, this.currentPage),
      this.sliderItemsToShow.length
    );

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.sliderItemOffset || this.sliderItemOffset <= 0) return;
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    const slideshowSectionId = normalizeSlideshowSectionId(
      this.closest('[id^="shopify-section-"]')?.id?.replace(/^shopify-section-/, '')
    );
    const applyPrependEmbedHide = () => {
      if (slideshowSectionId && hasPendingPrependEmbedForSlideshow(slideshowSectionId)) {
        hideSlideshowTrackForPrependEmbed(slideshowSectionId);
      }
    };
    applyPrependEmbedHide();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPrependEmbedHide);
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (!this._slideshowHideMediaListener) {
      this._slideshowHideMediaListener = () => {
        if (typeof this.refreshSlides === 'function') {
          this.refreshSlides();
        } else {
          this.resetPages();
        }
      };
      window.matchMedia('(min-width: 750px)').addEventListener('change', this._slideshowHideMediaListener);
    }

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      if (this.hasAttribute('data-await-prepend-embed')) {
        this.dataset.autoplayPending = 'true';
      } else {
        this.setAutoPlay();
      }
    }

    this.syncEmbedPagerIfNeeded();
  }

  syncEmbedPagerIfNeeded() {
    if (!this.slider) return;
    const visibleSlides = getVisibleSlideshowSlides(this.slider);
    const pagerLinks = this.querySelectorAll('.slideshow__control-wrapper .slider-counter__link');
    if (visibleSlides.length > pagerLinks.length) {
      this.refreshSlides();
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else if (this.reducedMotion) {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.prevButton) this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    const idx = Math.min(
      Math.max(0, (Number.isFinite(this.currentPage) ? this.currentPage : 1) - 1),
      this.sliderControlButtons.length - 1
    );
    this.sliderControlButtons[idx].classList.add('slider-counter__link--active');
    this.sliderControlButtons[idx].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (this.reducedMotion && !this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider && this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const visibleSlides = getVisibleSlideshowSlides(this.slider);
    if (!this.sliderItemOffset || this.sliderItemOffset <= 0 || visibleSlides.length < 1) return;
    const slideScrollPosition =
      this.currentPage === visibleSlides.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    if (!this.sliderItemsToShow?.length) return;
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const linkIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
    if (linkIndex < 0) return;
    const slides = getVisibleSlideshowSlides(this.slider);
    const targetSlide = slides[linkIndex];
    if (!targetSlide) return;
    const sliderRect = this.slider.getBoundingClientRect();
    const slideRect = targetSlide.getBoundingClientRect();
    const nextLeft = this.slider.scrollLeft + (slideRect.left - sliderRect.left);
    this.slider.scrollTo({
      left: nextLeft,
    });
  }

  /**
   * Re-query slides and pager after a slide node is appended (e.g. Image banner → Slideshow embed).
   * @param {{ goToFirst?: boolean }} [options] - If goToFirst, reset horizontal scroll so slide 1 is visible (use after prepending a slide).
   */
  refreshSlides(options) {
    if (!this.slider) return;
    options = options || {};

    if (options.goToFirst) {
      if (typeof this.slider.scrollTo === 'function') {
        this.slider.scrollTo({ left: 0, behavior: 'instant' });
      } else {
        this.slider.scrollLeft = 0;
      }
      this.currentPage = 1;
    }

    const visibleSlides = getVisibleSlideshowSlides(this.slider);
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderFirstItemNode = visibleSlides[0] || this.slider.querySelector('.slideshow__slide');

    this.querySelectorAll('.slideshow__controls.slider-buttons').forEach((controls) => {
      const hideControls = visibleSlides.length < 2;
      controls.hidden = hideControls;
      controls.classList.toggle('slideshow__controls--single-block', hideControls);
    });

    if (this.pageTotalElement) {
      this.pageTotalElement.textContent = visibleSlides.length;
    }

    const wrappers = this.querySelectorAll('.slideshow__control-wrapper');
    if (wrappers.length > 0) {
      const firstLink = this.querySelector('.slideshow__control-wrapper .slider-counter__link');
      let visualClass = 'slider-counter__link--dots';
      if (firstLink) {
        const m = firstLink.className.match(/slider-counter__link--(dots|numbers)/);
        if (m) visualClass = 'slider-counter__link--' + m[1];
      }
      const isNumbers = visualClass.endsWith('numbers');
      const loadWord = this.dataset.embedAriaLoad || 'Load slide';
      const ofWord = this.dataset.embedAriaOf || 'of';

      wrappers.forEach((wrapper) => {
        if (visibleSlides.length > 0) {
          wrapper.innerHTML = '';
          visibleSlides.forEach((item, index) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = `slider-counter__link ${visualClass} link`;
            btn.setAttribute(
              'aria-label',
              `${loadWord} ${index + 1} ${ofWord} ${visibleSlides.length}`
            );
            btn.setAttribute('aria-controls', this.slider.id);
            btn.dataset.slideId = item.id;
            btn.innerHTML = isNumbers ? String(index + 1) : '<span class="dot"></span>';
            btn.addEventListener('click', this.linkToSlide.bind(this));
            wrapper.appendChild(btn);
          });
        } else {
          wrapper.innerHTML = '';
        }
      });
      this.sliderControlLinksArray = Array.from(
        this.querySelectorAll('.slideshow__control-wrapper .slider-counter__link')
      );
    }

    this.resetPages();
    this.update();
    this.setSlideVisibility();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateMedia();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (gallery) {
      let variantMediaId = this.currentVariant?.featured_media?.id;
      if (variantMediaId) {
        gallery.querySelectorAll('.variant-images').forEach(function (variantImage, index) {
          variantImage.classList.add('hidden');
        });
        let elm = gallery.querySelector(
          `.product__media-item[data-media-id="${this.dataset.section}-${variantMediaId}"]`
        );
        elm.classList.remove('hidden');
        if (elm.parentNode.querySelector('.product__media-item:first-child').nextSibling) {
          elm.parentNode.insertBefore(
            elm,
            elm.parentNode.querySelector('.product__media-item:first-child').nextSibling
          );
        }
        gallery.swiperUpdateSlides();
        gallery.swiperUpdate();
        let elementShowing = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]')).filter(
          (elm) => elm.clientWidth > 0
        );
        let index = elementShowing.findIndex((media) => media == elm);
        if (index > -1) gallery.swiperSlideTo(index);
        else {
          //CHANGE DESKTOP PRODUCT SECOND IMAGE CONTENT WHEN THERE'S VARIANT IMAGE.
          const clone = elm.cloneNode(true);
          let desktopThumb = document.querySelector('.product__media-thumb');
          clone.classList = 'product__media-item grid__item product__media-item--full';
          desktopThumb.querySelector('li').remove();
          desktopThumb.prepend(clone);
          /*
          let item = Array.from(document.querySelectorAll(`.product__media-item[data-media-id="${this.dataset.section}-${variantMediaId}"]`)).filter((elm) => elm.clientWidth > 0)[0];
          item.classList.add('focus-media');
          setTimeout(() => {
            item.classList.remove('focus-media');
          }, 1000);
          */
        }
      }
    }
    return;
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        const bundleUpsellSource = html.getElementById(
          `ProductUpsellPicker-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const bundleUpsellDestination = document.getElementById(`ProductUpsellPicker-${this.dataset.section}`);
        const bundlePriceSource = html.getElementById(
          `BundlePrice-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const bundlePriceDestination = document.getElementById(`BundlePrice-${this.dataset.section}`);
        const bundleImageMobileSource = html.getElementById(
          `BundleImageMobile-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const bundleImageMobileDestination = document.getElementById(`BundleImageMobile-${this.dataset.section}`);
        const bundleImageDesktopSource = html.getElementById(
          `BundleImageDesktop-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const bundleImageDesktopDestination = document.getElementById(`BundleImageDesktop-${this.dataset.section}`);

        const bundleCrossSellSource = html.getElementById(
          `BundleCrossSell-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const bundleCrossSellDestination = document.getElementById(`BundleCrossSell-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'visibility-hidden',
            pricePerItemSource.classList.contains('visibility-hidden')
          );
        }

        if (bundleUpsellSource && bundleUpsellDestination) {
          bundleUpsellDestination.innerHTML = bundleUpsellSource.innerHTML;
        }
        if (bundlePriceSource && bundlePriceDestination) {
          bundlePriceDestination.innerHTML = bundlePriceSource.innerHTML;
        }
        if (bundleImageMobileSource && bundleImageMobileDestination) {
          bundleImageMobileDestination.innerHTML = bundleImageMobileSource.innerHTML;
        }
        if (bundleImageDesktopSource && bundleImageDesktopDestination) {
          bundleImageDesktopDestination.innerHTML = bundleImageDesktopSource.innerHTML;
        }

        if (bundleCrossSellSource && bundleCrossSellDestination) {
          bundleCrossSellDestination.innerHTML = bundleCrossSellSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        this.options.forEach((option, index) => {
          const optionsPerItemDestination =
            this.querySelector(
              `#Option${index}-${this.dataset.section}-${this.dataset.blockId}-${this.dataset.productId}`
            ) ||
            this.querySelector(
              `#Option${index}-${this.dataset.originalSection}-${this.dataset.blockId}-${this.dataset.productId}`
            );
          const optionsPerItemSource =
            html.querySelector(
              `#Option${index}-${this.dataset.originalSection}-${this.dataset.blockId}-${this.dataset.productId}`
            ) ||
            html.querySelector(
              `#Option${index}-${this.dataset.section}-${this.dataset.blockId}-${this.dataset.productId}`
            );
          if (optionsPerItemSource && optionsPerItemDestination) {
            optionsPerItemDestination.innerHTML = optionsPerItemSource.innerHTML;
          }
        });

        const klaviyoBtnDestination = this.closest('.shopify-section').querySelector(`#Manual-bis-btn`);
        const klaviyoBtnSource = html.querySelector(`#Manual-bis-btn`);
        if (klaviyoBtnDestination && klaviyoBtnSource) {
          klaviyoBtnDestination.dataset.currentVariant = klaviyoBtnSource.dataset.currentVariant;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class Accordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const toggle = this.hasAttribute('toggle');
    let listAcc = this.querySelectorAll('.js-accordion');

    listAcc.forEach((acc) => {
      if (acc.classList.contains('active')) {
        this.smallFunction(acc);
      }

      const panel = acc.nextElementSibling;
      if (panel) {
        this.setupHeightObserver(panel, acc);
      }

      acc.addEventListener('click', (e) => {
        if (e.target.nodeName === 'A') return;
        if (toggle) {
          let open = acc.classList.contains('active');
          listAcc.forEach((rmAcc) => {
            rmAcc.classList.remove('active');
            this.smallFunction(rmAcc);
          });

          if (!open) {
            acc.classList.add('active');
            this.smallFunction(acc);
          }
        } else {
          acc.classList.toggle('active');
          this.smallFunction(acc);
        }
      });
    });
    this.querySelectorAll('.opened').forEach((opened) => {
      opened.style.maxHeight = opened.scrollHeight + 'px';
      opened.classList.add('open');
    });
    window.addEventListener('resize', this.reSetHeight.bind(this));
  }

  smallFunction(elm) {
    let panel = elm.nextElementSibling;
    if (elm.classList.contains('active')) {
      panel.classList.add('open');
      requestAnimationFrame(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        if (panel.querySelector('video, img[data-lazyvids]')) {
          panel.style.maxHeight = 'none';
        }
      });
    } else {
      panel.style.maxHeight = null;
      panel.classList.remove('open', 'opened');
    }
  }

  setupHeightObserver(panel, acc) {
    const observer = new MutationObserver((mutations) => {
      if (acc.classList.contains('active') && panel.style.maxHeight !== 'none') {
        const prevHeight = parseInt(panel.style.maxHeight) || 0;
        const newHeight = panel.scrollHeight;
        if (Math.abs(newHeight - prevHeight) > 10) {
          panel.style.maxHeight = newHeight + 'px';
        }
      }
    });

    observer.observe(panel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'style']
    });

    this.addEventListener('disconnected', () => observer.disconnect(), { once: true });
  }

  reSetHeight() {
    this.querySelectorAll('.open').forEach((i) => {
      if (i.previousElementSibling.classList.contains('active')) {
        requestAnimationFrame(() => {
          i.style.maxHeight = i.scrollHeight + 'px';
          if (i.querySelector('video, img[data-lazyvids]')) {
            i.style.maxHeight = 'none';
          }
        });
      }
    });
  }
}
customElements.define('component-accordion', Accordion);

class BadgeProduct extends HTMLElement {
  constructor() {
    super();
    this.startAction();
  }

  startAction() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.badgeData =
      this.badgeData || JSON.parse(document.querySelector('#data-badge[type="application/json"]').textContent);
    this.currentVariantId = this.dataset.variantId;
    this.buildBadge(this.productData, this.badgeData);
  }
  buildBadge(product, badges) {
    let findBadge = badges.blocks.filter((block) => {
      if (block.type == 'label' || block.type == 'sold_out_threshold' || block.type == 'image') {
        let productTags = product.tags.map((tag) => tag.toLowerCase());
        if (productTags.includes(block.settings.handle)) {
          return block;
        }
      }
      if (block.type == 'sale' && product.compare_at_price > product.price) {
        return block;
      }
      if (block.type == 'sold_out' && !product.available) {
        return block;
      }
    });
    if (findBadge.length > 0 && !this.querySelector('.badge-product_container')) {
      let oldHtml = this.innerHTML;
      this.classList.add('badge-product', `badge-product--${this.badgeData.position_badge}`);
      this.innerHTML = this.htmlRender(findBadge) + oldHtml;
    }
  }
  htmlRender(badges) {
    let content = false;
    for (let index = 0; index < badges.length; index++) {
      const badge = badges[index];
      if (badge.type === 'image' && badge.settings.image !== '') {
        content = this.imageRender(badge);
      } else if (badge.type === 'sale') {
        content = this.textRender(badge, badge.settings.label !== '' ? badge.settings.label : 'Sale');
      } else if (badge.type === 'sold_out') {
        content = this.textRender(badge, badge.settings.label !== '' ? badge.settings.label : 'Sold out');
      } else if (badge.type === 'label') {
        let text = badge.settings.handle;
        if (badge.settings.label !== '') text = badge.settings.label;
        else if (badge.settings.handle.split('badge:').length > 1) text = badge.settings.handle.split('badge:')[1];
        content = this.textRender(badge, text);
      } else if (
        badge.type === 'sold_out_threshold' &&
        this.productData.variants.find((variant) => variant.id == Number(this.currentVariantId)).inventory_quantity <=
          badge.settings.number
      ) {
        content = this.textRender(badge, badge.settings.label !== '' ? badge.settings.label : 'Sold out');
      }
      if (content) break;
    }
    if (content) {
      return `<div class="badge-product_container">${content}</div>`;
    }
    return '';
  }
  imageRender(badge) {
    return `<img class="badge-product_image" src="${badge.settings.image}" alt="${badge.settings.handle}" width="50" height="50" loading="lazy" />`;
  }
  textRender(badge, text) {
    return `<span class="badge-product_text badge-product--${badge.settings.type}" style="--text-color: ${badge.settings.text_color};--style-color: ${badge.settings.style_color}">${text}</span>`;
  }
}
customElements.define('badge-product', BadgeProduct);
class VideoBreakpoint extends HTMLElement {
  constructor() {
    super();
    const windowMatches = window.matchMedia('screen and (min-width: 750px)');
    this.videoDesktop = this.querySelector('.js-desktop-video');
    this.videoMobile = this.querySelector('.js-mobile-video');
    this.isDesktop(windowMatches.matches);
    windowMatches.addEventListener('change', this.handleMatchChange.bind(this));
  }
  handleMatchChange(e) {
    this.isDesktop(e.matches);
  }
  isDesktop(isDesktop) {
    let videoPlay = this.videoDesktop;
    let videoPause = this.videoMobile;
    if (!isDesktop && this.videoMobile) {
      videoPlay = this.videoMobile;
      videoPause = this.videoDesktop;
    }
    if (videoPlay.readyState != 4) {
      videoPlay.load();
      videoPlay.onloadeddata = () => videoPlay.play();
    } else videoPlay.play();
    videoPause && videoPause.pause();
  }
}
customElements.define('video-breakpoint', VideoBreakpoint);

if (window.innerWidth < 750) {
  document.documentElement.style.setProperty('--window-height', `${Math.round(window.outerHeight)}px`);
} else {
  document.documentElement.style.setProperty('--window-height', `${Math.round(window.innerHeight)}px`);
}
document.documentElement.style.setProperty('--window-width', `${Math.round(document.body.offsetWidth)}px`);

if (document.querySelector('.announcement-bar-section')) {
  document.documentElement.style.setProperty(
    '--announcement-height',
    document.querySelector('.announcement-bar-section').offsetHeight + `px`
  );
} else {
  document.documentElement.style.setProperty('--announcement-height', 0 + `px`);
}
if (document.querySelector('.announcement-bar-section .announcement-bar.announcement-bar-transparent')) {
  document.body.classList.add('show-announcement-transparent');
} else {
}
if (document.querySelector('.header-wrapper').classList.contains('header-wrapper-transparent')) {
  document.body.classList.add('show-header-transparent');
}

window.addEventListener('resize', () => {
  if (window.innerWidth < 750) {
    document.documentElement.style.setProperty('--window-height', `${Math.round(window.outerHeight)}px`);
  } else {
    document.documentElement.style.setProperty('--window-height', `${Math.round(window.innerHeight)}px`);
  }
  document.documentElement.style.setProperty('--window-width', `${Math.round(document.body.offsetWidth)}px`);
  if (document.querySelector('.announcement-bar-section')) {
    document.documentElement.style.setProperty(
      '--announcement-height',
      document.querySelector('.announcement-bar-section').offsetHeight + `px`
    );
  } else {
    document.documentElement.style.setProperty('--announcement-height', 0 + `px`);
  }
});

class swiperSlider extends HTMLElement {
  constructor() {
    super();

    this.renderSlider();
  }
  renderSlider() {
    const slider = this.querySelector('.block-carousel');
    const sliderGallery = this.querySelector('.gallery-thumbs');
    const _this = this;
    let sliderComponent = null;
    let thumbs = null;
    if (sliderGallery) {
      thumbs = new Swiper(sliderGallery, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          750: {
            spaceBetween: 20,
          },
        },
      });
    }
    let options = {};
    let init = false;

    if (slider) {
      const btnNext = this.querySelector('.next');
      const btnPrev = this.querySelector('.prev');
      const swiperScrollbar = this.querySelector('.swiper-scrollbar');
      const slidesPerViewDesktop = parseFloat(slider.getAttribute('data-item_desktop')) || slider.getAttribute('data-item_desktop');
      const slidesPerViewMb = parseFloat(slider.getAttribute('data-item_mobile')) || slider.getAttribute('data-item_mobile');
      const slidesPaddingMb = slider.getAttribute('data-item_padding') ?? 10;
      const slidesPaddingDesktop = slider.getAttribute('data-item_padding') ?? 20;
      const is_loop = slider.getAttribute('data-loop');
      options = {
        loop: parseInt(is_loop),
        speed: 400,
        slidesPerView: slidesPerViewMb,
        spaceBetween: slidesPaddingMb,
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
        scrollbar: {
          el: swiperScrollbar,
          draggable: true,
          dragSize: 118,
        },
        breakpoints: {
          750: {
            slidesPerView: slidesPerViewDesktop,
            slidesPerGroup: 1,
            spaceBetween: slidesPaddingDesktop,
          },
          scrollbar: {
            dragSize: 388,
          },
        },
        thumbs: {
          swiper: thumbs,
        },
      };
      if (this.classList.contains('mobile-peek-slider') && window.innerWidth < 750) {
        this.classList.add('mobile-peek-active');
      } else if (this.classList.contains('disabled-slide-mobile') && window.innerWidth < 750) {
      } else {
        sliderComponent = new Swiper(slider, options);
        init = true;
      }
    }

    let heightImage = slider.children[0].children[0].querySelector('.card__inner');
    if (heightImage) {
      const heightImageH = heightImage.offsetHeight;
      slider.parentElement.style.setProperty('--slide-height-margin', heightImageH + `px`);
    }
    if (sliderGallery) {
      let thumbsH = sliderGallery.offsetHeight;
      slider.parentElement.style.setProperty('--slide-height-thumbs', thumbsH + `px`);
    }
    const resizeObserver = new ResizeObserver((entries) =>
      entries.forEach((entry) => {
        let heightImage = slider.children[0].children[0].querySelector('.card__inner');
        if (heightImage) {
          const heightImageH = heightImage.offsetHeight;
          slider.parentElement.style.setProperty('--slide-height-margin', heightImageH + `px`);
        }
        if (sliderGallery) {
          let thumbsH = sliderGallery.offsetHeight;
          slider.parentElement.style.setProperty('--slide-height-thumbs', thumbsH + `px`);
        }
      })
    );
    resizeObserver.observe(document.body);
    window.addEventListener('resize', () => {
      if (window.innerWidth > 750) {
        if (!init) {
          init = true;
          sliderComponent = new Swiper(slider, options);
        }
      } else if (init && this.classList.contains('disabled-slide-mobile')) {
        sliderComponent.destroy();
        init = false;
      }
    });
  }
}
customElements.define('swiper-container', swiperSlider);

class CollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (document.querySelectorAll('.banner-collection-tile')) {
      this.insertBanner();
    }
  }

  insertBanner() {
    const banners = document.querySelectorAll('.banner-collection-tile');
    if (!banners || document.querySelector('#banner-item')) {
      return;
    }

    let self = this;
    let countItems = this.querySelectorAll('div.grid__item').length;
    banners.forEach((banner) => {
      console.log('test');
      const positionB = banner.getAttribute('data-block-position');
      const controlSize = banner.getAttribute('data-controls-size');
      const controlSize_Mb = banner.getAttribute('data-controls-size-mb');
      banner.style.display = 'none';
      let div = document.createElement('div');

      div.setAttribute('class', 'grid__item  grid__item--collection');
      div.setAttribute('control_sizes', controlSize);
      div.setAttribute('control_sizes_mb', controlSize_Mb);
      div.innerHTML = banner.innerHTML;
      for (var i = 1; i < countItems; i++) {
        if (i == parseInt(positionB)) {
          self.insertBefore(div.cloneNode(true), self.querySelectorAll('div.grid__item')[i]);
        }
      }
    });
  }
}

customElements.define('collection-grid', CollectionGrid);

document.addEventListener('shopify:section:load', function (event) {
  const collectionGrid = new CollectionGrid();
  collectionGrid.init();
});

document.querySelector('#Details-menu-drawer-container').onclick = () => {
  const menuMobileOpen = document.querySelector('.js-search-mobile.open');
  if (menuMobileOpen) {
    document.querySelector('.js-search-mobile').classList.remove('open');
  }
};

const menuMobileEL = document.querySelector('.js-search-mobile');

menuMobileEL.onclick = () => {
  document.querySelector('#Details-menu-drawer-container .header__icon--menu').click();
  // document.querySelector("#HeaderDrawer-search").click();
  document.querySelector('.menu-drawer__navigation .menu-drawer__menu').classList.add('submenu-open');
  document.querySelector('#Details-menu-drawer-menu-item-search').classList.add('menu-opening');
  document.querySelector('#Details-menu-drawer-menu-item-search').setAttribute('open', true);
  document.querySelector('#HeaderDrawer-search').setAttribute('aria-expanded', true);
};

//PRODUCT PAGE DESKTOP CUSTOM IMAGE SCROLL
window.addEventListener('DOMContentLoaded', () => {
  var deltaYStack = 0;
  var isSliding = false;
  const deltaYThreshold = 180;
  const timingThreshold = 350; //miliseconds
  var windowOffsetY = window.pageYOffset;
  const productImageSwiper = document.querySelector('body.template--product .product__media-wrapper .swiper');
  if (window.innerWidth > 990 && productImageSwiper && productImageSwiper.swiper) {
    productImageSwiper.swiper.sensitivity = 0;
    productImageSwiper.swiper.noMousewheelClass = 'product__media-main';
    productImageSwiper.swiper.releaseOnEdges = true;
    productImageSwiper.swiper.update();
    productImageSwiper.swiper.on('slideChangeTransitionEnd', function () {
      //productImageSwiper.swiper.disable();
      setTimeout(function () {
        productImageSwiper.swiper.enable();
      }, timingThreshold);
    });
  }

  if (window.innerWidth > 990 && windowOffsetY == 0 && productImageSwiper && productImageSwiper.swiper) {
    //window.addEventListener("wheel",productPageScroll, {passive: false});
  }
  window.addEventListener('scroll', function (event) {
    var windowOffsetY = window.pageYOffset;
    const productImageSwiper = document.querySelector('body.template--product .product__media-wrapper .swiper');
    if (window.innerWidth > 990 && windowOffsetY == 0 && productImageSwiper && productImageSwiper.swiper) {
      //window.addEventListener("wheel",productPageScroll, {passive: false});
    } else {
      window.removeEventListener('wheel', productPageScroll);
      if (productImageSwiper) productImageSwiper.swiper.enable();
    }
  });

  window.addEventListener('resize', function (event) {
    var windowOffsetY = window.pageYOffset;
    const productImageSwiper = document.querySelector('body.template--product .product__media-wrapper .swiper');
    if (window.innerWidth <= 990 && windowOffsetY == 0 && productImageSwiper && productImageSwiper.swiper) {
      window.removeEventListener('wheel', productPageScroll);
      if (productImageSwiper) productImageSwiper.swiper.enable();
    }
  });
  function productPageScroll(event) {
    //console.log(event.deltaY);
    const productImageSwiper = document.querySelector('body.template--product .product__media-wrapper .swiper');
    if (document.body.classList.contains('overflow-hidden')) {
      window.removeEventListener('wheel', productPageScroll);
      if (productImageSwiper) productImageSwiper.swiper.enable();
    }
    event.preventDefault();
    event.stopPropagation();
    var windowOffsetY = window.pageYOffset;
    deltaYStack += event.deltaY;
    //console.log(deltaYStack);
    if (deltaYStack > deltaYThreshold) {
      deltaYStack = 0;
      if (productImageSwiper.swiper.isEnd) {
        window.removeEventListener('wheel', productPageScroll);
      }
      if (productImageSwiper && productImageSwiper.swiper && !productImageSwiper.swiper.isEnd && !isSliding) {
        //productImageSwiper.swiper.enable()
        productImageSwiper.swiper.slideNext();
        isSliding = true;
        setTimeout(function () {
          isSliding = false;
        }, timingThreshold);
      }
    }
    if (deltaYStack < -deltaYThreshold) {
      deltaYStack = 0;
      if (productImageSwiper && productImageSwiper.swiper && !productImageSwiper.swiper.isBeginning && !isSliding) {
        //productImageSwiper.swiper.enable()
        productImageSwiper.swiper.slidePrev();
        isSliding = true;
        setTimeout(function () {
          isSliding = false;
        }, timingThreshold);
      }
    }
    return false;
  }
});

class VideoContainer extends HTMLElement {
  constructor() {
    super();
    const video = this.querySelector('video');
    const circlePlayButton = this.querySelector('.play-button-wrapper');
    if (video) {
      const slideWrap = video.closest('.swiper-slide');
      const swiperContainer = video.closest('swiper-container');
      let isPlayed = false;
      circlePlayButton.addEventListener('click', (event) => {
        let isSlideActived = slideWrap.classList.contains('swiper-slide-active');
        let isPlaying =
          video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
        if (isSlideActived && (!isPlaying || !isPlayed)) {
          isPlayed = true;
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('timeupdate', function () {
        let isSlideActived = slideWrap.classList.contains('swiper-slide-active');
        if (isSlideActived) {
          const slideIndex = slideWrap.getAttribute('aria-label');
          const thumbsWrap = swiperContainer.querySelector('.gallery-thumbs');
          const thumbs = thumbsWrap.querySelectorAll('.swiper-slide');
          thumbs.forEach((thumb) => {
            if (thumb.getAttribute('aria-label') == slideIndex) {
              let seekbar = thumb.querySelector('.video_seekbar');
              let percentage = (video.currentTime / video.duration) * 100;
              if (seekbar) {
                seekbar.style.width = percentage + '%';
              }
            }
          });
        }
      });

      video.addEventListener('playing', function () {
        circlePlayButton.style.opacity = 0;
      });
      video.addEventListener('pause', function () {
        circlePlayButton.style.opacity = 1;
      });
      if (slideWrap.classList.contains('swiper-slide-active')) {
        circlePlayButton.dispatchEvent(new Event('click'));
      }
    }
  }
}

customElements.define('video-container', VideoContainer);

class PromotionProduct extends HTMLElement {
  constructor() {
    super();
    this.selectBtn = this.querySelector('button[type="button"]');
    this.selectBtn && this.selectBtn.addEventListener('click', this.showOptions.bind(this));

    this.elmOptions = this.querySelector('.options');
    this.submitButton = this.querySelector('button[type="submit"]');

    this.form = this.querySelector('form');
    this.form.addEventListener('change', this.changeHandler.bind(this));

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  showOptions() {
    if (this.elmOptions) {
      this.elmOptions.style.setProperty('--scroll-height', `${this.elmOptions.scrollHeight}px`);
      this.elmOptions.classList.add('show');
    }
  }
  hideOptions() {
    this.elmOptions && this.elmOptions.classList.remove('show');
  }

  changeHandler() {
    this.updateOptions();
    this.updateMasterId();
    this.updateInfo();
    this.updateSubmitButton();
    this.updateVariantId();
    this.selectBtn.classList.add('hidden');
    this.submitButton.classList.add('show');
  }

  updateVariantId() {
    this.querySelector('input[name="id"]').value = this.currentVariant.id;
  }

  updateInfo() {
    this.currentVariant.options.forEach((option, index) => {
      this.querySelector(
        `#Option${index}-${this.dataset.sectionId}-${this.dataset.blockId}-${this.dataset.productId} b`
      ).textContent = option;
    });
  }

  updateSubmitButton() {
    let btnAvailable = this.currentVariant.available;
    let listThreshold = this.getBadgeData()
      ? this.getBadgeData().blocks.filter((b) => b.type === 'sold_out_threshold')
      : [];
    let matchTag = listThreshold.filter((list) => this.getProductData().tags.includes(list.settings.handle));
    let notEnough = matchTag.some((i) => i.settings.number >= this.currentVariant.inventory_quantity);
    if (notEnough) btnAvailable = false;
    this.submitButton.textContent = btnAvailable
      ? this.submitButton.dataset.textAdd
      : this.submitButton.dataset.textSoldout;
    this.submitButton.disabled = !btnAvailable;
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  getBadgeData() {
    this.badgeData =
      this.badgeData || JSON.parse(document.querySelector('#data-badge[type="application/json"]').textContent) || null;
    return this.badgeData;
  }
  getVariantData() {
    this.variantData = this.getProductData().variants;
    return this.variantData;
  }
  getProductData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData;
  }
}
customElements.define('promotion-product', PromotionProduct);

/* RECHECK CART COUNT ON PAGE LOAD */
window.addEventListener('pageshow', function (event) {
  var historyTraversal =
    event.persisted || (typeof window.performance != 'undefined' && window.performance.navigation.type === 2);
  if (historyTraversal) {
    setTimeout(function () {
      var sectionsString = '';
      if (document.querySelector('cart-notification')) {
        sectionsString = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
      }
      if (document.querySelector('cart-drawer')) {
        sectionsString = 'cart-drawer,cart-icon-bubble';
      }
      fetch('/?sections=' + sectionsString)
        .then((response) => response.json())
        .then((response) => {
          var parsedState = {};
          parsedState.sections = response;
          //console.log(parsedState);
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.cart.renderContents(parsedState);
        });
    }, 100);
  }
});

window.addEventListener('freeGiftUpdate', function (event) {
  var sectionsString = '';
  if (document.querySelector('cart-notification')) {
    sectionsString = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
  }
  if (document.querySelector('cart-drawer')) {
    sectionsString = 'cart-drawer,cart-icon-bubble';
  }
  fetch('/?sections=' + sectionsString)
    .then((response) => response.json())
    .then((response) => {
      var parsedState = {};
      parsedState.sections = response;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cart.renderContents(parsedState);

      if (parsedState.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
        console.log(html);
        if (html.querySelector('cart-drawer.is-empty')) {
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          if (cartDrawerWrapper) cartDrawerWrapper.classList.add('is-empty');
        }
      }
    });
});

/* CHECK TOLSTOY WIDTH IN HOMEPAGE */
window.addEventListener('resize', function (event) {
  setTimeout(function () {
    if (document.querySelector('.tolstoy-carousel-container')) {
      document.querySelector('.tolstoy-carousel-container').style.maxWidth = '';
    }
  }, 100);
});

/*
 * Manual BIS Popup
 */
const manualBISpopup = document.querySelector('.manual-bis-popup');

/**
 * Product / collection cards: touch to reveal the secondary image where CSS :hover is unavailable.
 *
 * The image swaps as soon as the finger (or hovering pen) lands on a card and stays swapped after
 * the finger lifts, until another card is touched. A tap on a card that was already showing its
 * secondary image follows the product link.
 */
(function () {
  var TAP_MOVE_TOLERANCE = 10;

  var activeCardMedia = null;
  var activePointerId = null;
  var pointerStartX = 0;
  var pointerStartY = 0;
  var pointerMoved = false;
  var lastPointerX = 0;
  var lastPointerY = 0;
  var revealRaf = null;
  var gestureCardMedia = null;
  var gestureWasRevealed = false;

  function secondaryHoverFromCss() {
    return (
      window.matchMedia('(min-width: 990px)').matches &&
      window.matchMedia('(hover: hover)').matches &&
      window.matchMedia('(pointer: fine)').matches
    );
  }

  function secondaryImageDisabledForMedia(cardMedia) {
    var section = cardMedia.closest('.section-featured_collection');
    if (!section) return false;

    if (window.matchMedia('(max-width: 749px)').matches) {
      return section.classList.contains('section-featured_collection--no-secondary-image-mobile');
    }

    if (window.matchMedia('(min-width: 990px)').matches) {
      return section.classList.contains('section-featured_collection--no-secondary-image-desktop');
    }

    return section.classList.contains('section-featured_collection--no-secondary-image-mobile');
  }

  function isCardMediaInActiveCollectionSlider(cardMedia) {
    var slider = cardMedia.closest('.collection-slider');
    return !slider || slider.classList.contains('active');
  }

  function isValidCardMedia(cardMedia) {
    if (!cardMedia) return false;
    if (!cardMedia.classList.contains('card__media--show-secondary-mobile')) return false;
    if (!isCardMediaInActiveCollectionSlider(cardMedia)) return false;
    if (secondaryImageDisabledForMedia(cardMedia)) return false;

    var media = cardMedia.querySelector('.media.media--hover-effect');
    return !!(media && media.querySelector('img + img'));
  }

  function isInteractiveTarget(target) {
    return !!target.closest(
      'button, input, select, textarea, label, [role="button"], .quick-add, .quick-add__submit, .product__card-options'
    );
  }

  function clearTouchSecondary() {
    document.querySelectorAll('.card__media--touch-secondary').forEach(function (el) {
      el.classList.remove('card__media--touch-secondary');
    });

    activeCardMedia = null;
  }

  function setTouchSecondary(cardMedia) {
    if (activeCardMedia === cardMedia && cardMedia.classList.contains('card__media--touch-secondary')) return;

    clearTouchSecondary();
    activeCardMedia = cardMedia;
    cardMedia.classList.add('card__media--touch-secondary');
  }

  function cardMediaFromElement(element) {
    if (!element || !element.closest) return null;
    if (isInteractiveTarget(element)) return null;

    var cardMedia = element.closest('.card__media');
    return isValidCardMedia(cardMedia) ? cardMedia : null;
  }

  function revealAtPoint(clientX, clientY) {
    var cardMedia = cardMediaFromElement(document.elementFromPoint(clientX, clientY));
    if (cardMedia) setTouchSecondary(cardMedia);
  }

  function scheduleReveal() {
    if (revealRaf) return;

    revealRaf = requestAnimationFrame(function () {
      revealRaf = null;
      revealAtPoint(lastPointerX, lastPointerY);
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
      pointerMoved = false;
      gestureCardMedia = null;
      gestureWasRevealed = false;

      if (secondaryHoverFromCss()) return;

      var cardMedia = cardMediaFromElement(event.target);
      if (!cardMedia) return;

      gestureCardMedia = cardMedia;
      gestureWasRevealed = cardMedia.classList.contains('card__media--touch-secondary');
      setTouchSecondary(cardMedia);
    },
    true
  );

  // A pen hovering above the screen reports pointerover without ever touching down.
  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType !== 'pen') return;
      if (secondaryHoverFromCss()) return;

      var cardMedia = cardMediaFromElement(event.target);
      if (cardMedia) setTouchSecondary(cardMedia);
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (activePointerId === null || event.pointerId !== activePointerId) return;

      if (
        !pointerMoved &&
        (Math.abs(event.clientX - pointerStartX) > TAP_MOVE_TOLERANCE ||
          Math.abs(event.clientY - pointerStartY) > TAP_MOVE_TOLERANCE)
      ) {
        pointerMoved = true;
      }

      if (secondaryHoverFromCss()) return;

      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
      scheduleReveal();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (secondaryHoverFromCss()) return;
      if (!event.target || !event.target.closest) return;

      var cardMedia = event.target.closest('.card__media');

      // The reveal stays put until another product card is touched.
      if (!cardMedia || !isValidCardMedia(cardMedia) || isInteractiveTarget(event.target)) return;

      // Carousel swipes and keyboard-triggered clicks must not swallow the link.
      if (pointerMoved || event.detail === 0) return;

      // The touch that started this gesture already did the reveal, so let the link through.
      if (gestureWasRevealed && gestureCardMedia === cardMedia) return;

      event.preventDefault();
      event.stopPropagation();
      setTouchSecondary(cardMedia);
    },
    true
  );
})();

if (manualBISpopup) {
  const manualBISform = manualBISpopup.querySelector('form');

  /* Delegated rather than bound per trigger: notify buttons arrive after load too, from the
     sibling colour switcher on a product page and from "Show more" on a collection page. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    const element = event.target.closest('.manual-bis-trigger');
    if (!element) return;

    event.preventDefault();
    manualBISpopup.querySelector('.manual-bis-popup__product').textContent = element.dataset.prod_title;
    manualBISpopup.querySelector('[name="product"]').value = element.dataset.prod_id;
    manualBISpopup.querySelector('[name="variant"]').value = element.dataset.var_id;
    manualBISform.querySelector('[name="email"]').value = '';

    manualBISpopup.classList.remove('hidden');
    // Vanilla JS fadeIn equivalent
    manualBISpopup.style.display = 'block';
    manualBISpopup.style.opacity = '0';
    manualBISpopup.style.transition = 'opacity 200ms ease-in-out';
    setTimeout(() => {
      manualBISpopup.style.opacity = '1';
    }, 10);

    // Add show class to afterpay-paragraph to stop it from being hidden when interacting with the popup
    const afterpayParagraphs = document.querySelectorAll('.afterpay-paragraph');
    afterpayParagraphs.forEach((paragraph) => paragraph.classList.add('show'));
  });
}
